import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'

@Component({
  selector: 'dmmp-website-news',
  templateUrl: './website-news.component.html'
})
export class WebsiteNewsComponent implements OnInit {

  @Input() module
  @Input() identifier
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()

  constructor() {
  }

  ngOnInit() {
  }

}
